import axios from 'axios';

export class RequestHelper {
  // 本番・ローカルで出し分ける必要があるが、後回し
  static baseUrl = 'https://api.syncable.biz/';

  /**
   * @param {String} appendUrl - baseUrlの後に続くURL
   */
  static async get(appendUrl) {
    return axios.get(`${this.baseUrl}${appendUrl}`);
  }
}
